import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * AuthImage: fetches a protected file via the API as a blob and renders it.
 * Cleans up the blob URL on unmount.
 */
export default function AuthImage({ photoId, alt = "", className = "" }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    let blobUrl = null;
    if (!photoId) return;
    api
      .get(`/files/${photoId}`, { responseType: "blob" })
      .then((resp) => {
        if (!active) return;
        blobUrl = URL.createObjectURL(resp.data);
        setSrc(blobUrl);
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => {
      active = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [photoId]);

  if (error) {
    return (
      <div className={`flex items-center justify-center bg-[#F3F1E9] text-[#8a8a8a] text-xs ${className}`}>
        Unavailable
      </div>
    );
  }
  if (!src) {
    return <div className={`bg-[#F3F1E9] animate-pulse ${className}`} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
